<template>
  <div class="page main-background">
    <div class="sub-header">
      <h2>لیست خودرو ها</h2>
    </div>
    <!-- <div class="sub-header-color colorWhite">
      <div class="dFlex" style="justify-content: flex-start;">
        <router-link :to="{ path: '/car-info/home'}">
          <div class="textCenter" style="width: 50px; ">
            <i class="far fa-arrow-right colorWhite"></i>
          </div>
        </router-link>
        <h2>لیست خودرو</h2>
      </div>
    </div> -->
    <div class="text-color border-color" style="position: relative">
      <div v-if="!loader" class="car-info">
        <div class="tabs">
          <div class="tab-body">
            <div ref="brandsBody">
              <router-link tag="div" class="brand-item card" :to="{ path: '/car-info/detail/' + model.id }"
                v-for="model in models" :key="model.Id">
                <img class="pic" :src="model.thumbnailUrl" />
                <div>
                  <h3>
                    {{model.faTitle}}
                    <div class="year">{{model.years}}</div>
                  </h3>
                  <div>
                    <div class="more">
                      <img src="../../assets/img/arrow-left.png" />
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
            <div ref="countriesBody"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import api from "../../service";

export default {
  name: "car-info-home",
  props: {
    brandId: {
      type: String,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      loading: false,
      models: [],
    };
  },
  mounted: function () {
    this.loading = true;
    api.getCarListByBrandId(this.brandId).then((response) => {
      console.log(response);
      if (response.data && response.data.status === 200) {
        this.models = response.data.data;
      }
    });
  },
  methods: {
    ...mapActions(["setTheme", "setToken"])
  },
  computed: {},
};
</script>
<style scoped>
.card {
  box-shadow: rgba(175, 177, 178, 0.46) 0px 0px 4px 1px;
  margin: 10px 10px 0 10px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  position: relative;
}

.car-info {
  display: flex;
}

.tabs {
  display: flex;
  max-width: 100%;
  flex: 1;
  flex-direction: column;
}

.tabs>.tab-header {
  display: flex;
  flex-direction: row;
  height: 42px;
  align-items: center;
}

.tabs>.tab-header>div {
  line-height: 42px;
  height: 42px;
}

.tabs>.tab-header>div.active {
  background-color: #09389f;
  color: #fff;
}

.brand-item {
  position: relative;
  background: #fff;
}

.brand-item>img.logo {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 80px;
  height: 80px;
  z-index: 2;
}

.brand-item>img.pic {
  position: relative;
  width: 200px;
  margin-bottom: 10px;
  border-radius: 5px 5px 0 0;
  margin: 0 auto;
}

.brand-item>h3 {
  font-size: 1.2em;
  height: 30px;
  line-height: 30px;
  padding-right: 10px;
}

.brand-item>div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  text-align: right;
  align-items: center;
  background: #eee;
  border-radius: 0 0 5px 5px;
  padding: 10px;
}

.dark .brand-item>div {
  background: none;
}

.car-info .more {
  background-color: #09389f;
  padding: 5px;
  border-radius: 5px;
  height: 40px;
  width: 40px;
}

.car-info .more img {
  width: 30px;
}

.car-info .year {
  color: #09389f;
  font-size: 13px;
}

.dark .car-info .year {
  color: #bababa
}
</style>